// utils/currency/index.js
//
// The currency module: ISO 4217 registry + parsing + normalisation +
// formatting for the `currency` element type. Every file in this folder is
// dependency-free and vendored verbatim into keepr-web; see registry.js for
// the rule and docs/plans/currency.md (keepr-web) for the contract.

'use strict';

const registry = require('./registry');
const parse = require('./parse');
const normalize = require('./normalize');
const format = require('./format');

module.exports = {
	// Registry.
	CURRENCIES: registry.CURRENCIES,
	CURRENCY_LIST: registry.CURRENCY_LIST,
	MAX_AMOUNT: registry.MAX_AMOUNT,
	getCurrency: registry.getCurrency,
	isCurrencyCode: registry.isCurrencyCode,
	exponentOf: registry.exponentOf,
	allowedCodes: registry.allowedCodes,
	defaultCodeOf: registry.defaultCodeOf,
	resolveCurrency: registry.resolveCurrency,
	isCurrencyValue: registry.isCurrencyValue,

	// Parsing.
	decimalTextOf: parse.decimalTextOf,
	toMinor: parse.toMinor,
	parseCurrency: parse.parseCurrency,
	parseCurrencyDetailed: parse.parseCurrencyDetailed,

	// Normalisation.
	normalizeCurrency: normalize.normalizeCurrency,
	readCurrency: normalize.readCurrency,

	// Formatting.
	STYLES: format.STYLES,
	majorText: format.majorText,
	toMajor: format.toMajor,
	symbolFor: format.symbolFor,
	formatAmount: format.formatAmount,
	formatCurrency: format.formatCurrency,
	formatMajor: format.formatMajor,
};
